import { reduce, isPlainObject } from 'lodash';

/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const ObjectEmptyStringToNull = object => {
  return reduce(
    object,
    (result, value, key) => {
      if (value === '') {
        result[key] = null;
      } else if (isPlainObject(value)) {
        result[key] = ObjectEmptyStringToNull(value);
      } else {
        result[key] = value;
      }
      return result;
    },
    {},
  );
};

/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const ObjectNullToEmptyString = object => {
  const newObject = reduce(
    object,
    (result, value, key) => {
      if (value === null) {
        result[key] = '';
      } else {
        result[key] = value;
      }
      return result;
    },
    {},
  );
  return newObject;
};

const hexToRbg = hex => {
  const hexInt = parseInt(hex.slice(1), 16);

  const r = (hexInt >> 16) & 255;
  const g = (hexInt >> 8) & 255;
  const b = hexInt & 255;

  return { r, g, b };
};

/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const hexToRgba = (hex, opacity) => {
  const { r, g, b } = hexToRbg(hex);
  const a = opacity;

  return `rgba(${r},${g},${b},${a})`;
};

/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const getMonochromeRBGValueForColor = hex => {
  const { r, b, g } = hexToRbg(hex);
  return (r + b + g) / 3;
};

/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const copyToClipboard = str => {
  const el = document.createElement('textarea');
  el.value = str;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};
